import React from "react";

const SoundEffects: React.FC = () => {
    return <h1>Sound Effects Page</h1>;
};

export default SoundEffects;
